import type { QuestionTimelineItemEntry } from '~/types'

import { getAnswers } from './cardUtils'
import MultipleQuestions from './MultipleQuestions'
import OneQuestion from './OneQuestion'

const QuestionCardContent = ({
  entries,
  hasDifferedBusinessEntries,
}: {
  entries: QuestionTimelineItemEntry[]
  hasDifferedBusinessEntries: boolean
}) => {
  const hasMultipleQuestions = entries.length > 1
  const answers = getAnswers(entries)
  const [currentAnswers, ...previousAnswers] = answers

  return (
    <>
      <OneQuestion
        question={currentAnswers}
        showAppointmentButton={hasMultipleQuestions}
      />
      {hasMultipleQuestions && (
        <MultipleQuestions
          enableBusinessShareIcon={hasDifferedBusinessEntries}
          questions={previousAnswers}
        />
      )}
    </>
  )
}

export default QuestionCardContent
